import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as CertificationDocActions from '../_actions/certificationDoc';
import { CertificationDoc } from '../_models/certificationDoc';

export interface CertificationDocState extends EntityState<CertificationDoc> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<CertificationDoc> = createEntityAdapter<CertificationDoc>();

const initialState: CertificationDocState = adapter.getInitialState({
  loading: false,
  error: null,
});

const certificationDocReducer = createReducer(
  initialState,

  on(CertificationDocActions.loadCertificationDocs, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(CertificationDocActions.loadCertificationDocsSuccess, (state, { certificationDocs }) =>
    adapter.setAll(certificationDocs, { ...state, loading: false })
  ),

  on(CertificationDocActions.loadCertificationDocsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(CertificationDocActions.addCertificationDocSuccess, (state, { certificationDoc }) =>
    adapter.addOne(certificationDoc, state)
  ),

  on(CertificationDocActions.updateCertificationDocSuccess, (state, { certificationDoc }) =>
    adapter.upsertOne(certificationDoc, state)
  ),

  on(CertificationDocActions.deleteCertificationDocSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    CertificationDocActions.addCertificationDocFailure,
    CertificationDocActions.updateCertificationDocFailure,
    CertificationDocActions.deleteCertificationDocFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: CertificationDocState | undefined, action: Action) {
  return certificationDocReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
